import { Button, Card, CardHeader, Divider, IconButton, List, ListItem, ListItemText, Paper, Typography } from '@material-ui/core'
import { AccountCircleOutlined, AddCircle, Assignment, Attachment, CloudDownload, Edit } from '@material-ui/icons'
import React, { useCallback, useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import yourlogohere from '../../resources/images/yourlogohere.png'
import { showPlotsFromPartNumber } from '../../store/helpers/ShowPlotToPartNumber'
import { searchByPartNumbersByQury } from '../../store/partNumbers/PartNumberAction'
import { editCustomsData, getDocumentsToCustomsBroker, loadShippingOrderFromBackEnd, removeFilesShippingOrder, sendAditionalDocumentsShippingOrderToClient, uploadFilesShippingOrder } from '../../store/shippingOrders/ShippingOrderAction'
import { loadSupplierCode } from '../../store/suppliers/SupplierActions'
import DataTable from '../common/DataTable'
import DialogAvailableOperations from '../common/DialogAvailableOperations'
import FloatingButton from '../common/FloatingButton'
import LateralPanelContainer from '../common/LateralPanelComponents/LateralPanelContainer'
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import IndexViewEdit from './components/IndexViewEdit'
import IndexSendDocuments from './components/indexSendDocuments'

const Show = () => {
    const dispatch = useDispatch()
    const params = useParams()
    const [identifierPanelLateral, setIdentifierPanelLateral] = useState('')
    const [documents, setDocuments] = useState([])
    const [openAvailableOperationsDialog, setOpenAvailableOperationsDialog] = useState(false)
    const [selectedItem, setSelectedItem] = useState({ destinationPlace: '' })
    let userRolesByCompany = useSelector((state) => state.profile.get('userRolesByCompany').toJS())
    const shippingOrder = useSelector((state) => state.shippingOrders.get('shippingOrder') ? state.shippingOrders.get('shippingOrder').toJS() : [])
    const supplier = useSelector((state) => state.suppliers.get("supplier") ? state.suppliers.get("supplier").toJS() : null)
    useEffect(() => {
        dispatch(getDocumentsToCustomsBroker(params.token)).then((data) => {
            setDocuments(data.Data[0])
        })
    }, [dispatch])

    let supplierLogo = supplier ? supplier.logo : ''
    let urlImageSupplier = `${process.env.REACT_APP_IDENTITY_SERVER}${supplierLogo}`
    useEffect(() => {
        dispatch(loadShippingOrderFromBackEnd(params.token))
    }, [dispatch])
    useEffect(() => {
        if (shippingOrder)
            dispatch(loadSupplierCode(shippingOrder.supplier_code))
    }, [dispatch])

    const onEditCustomsData = (data) => {
        dispatch(editCustomsData(data))
            .then(() => {
                onOpenAndCloseLateralPanel()
            })
            .catch(() => {
                console.error('Error saving delivery image evidence')
            })
    }

    const onSendAditionalDocuments = () => {
        dispatch(sendAditionalDocumentsShippingOrderToClient(shippingOrder.token, 'upload'))
            .then(() => {
                onOpenAndCloseLateralPanel()
            })
            .catch(() => {
                console.error('Error saving delivery image evidence')
            })
    }

    const onSendAditionalDocumentsWithStatus = () => {
        dispatch(sendAditionalDocumentsShippingOrderToClient(shippingOrder.token, 'send'))
            .then(() => {
                setOpenDialog(false)
            })
            .catch(() => {
                console.error('Error saving delivery image evidence')
            })
    }

    const onUploadAtitionalDocuments = (files) => {
        return dispatch(uploadFilesShippingOrder(shippingOrder.response.token, files, "AditionalDocuments", "aditional_documents"))
    }

    const onRemoveAditionalFiles = (fileName) => {
        return dispatch(removeFilesShippingOrder(shippingOrder.response.token, fileName, "AditionalDocuments", "aditional_documents"))
    }

    const onUploadPaidRequestCustoms = (files) => {
        return dispatch(uploadFilesShippingOrder(shippingOrder.response.token, files, "PaidRequestCustoms", "paid_request_customs"))
    }

    const onRemovePaidRequestCustoms = (fileName) => {
        return dispatch(removeFilesShippingOrder(shippingOrder.response.token, fileName, "PaidRequestCustoms", "paid_request_customs"))
    }


    const onUploadCustomsAgentExpenseAccount = (files) => {
        return dispatch(uploadFilesShippingOrder(shippingOrder.response.token, files, "CustomsAgentExpenseAccount", "customs_agent_expense_account"))
    }

    const onRemoveCustomsAgentExpenseAccount = (fileName) => {
        return dispatch(removeFilesShippingOrder(shippingOrder.response.token, fileName, "CustomsAgentExpenseAccount", "customs_agent_expense_account"))
    }

    const onUploadCustomsAgentAdvancePaymentRequest = (files) => {
        return dispatch(uploadFilesShippingOrder(shippingOrder.response.token, files, "CustomsAgentAdvancePaymentRequest", "customs_agent_advance_payment_request"))
    }

    const onRemoveCustomsAgentAdvancePaymentRequest = (fileName) => {
        return dispatch(removeFilesShippingOrder(shippingOrder.response.token, fileName, "CustomsAgentAdvancePaymentRequest", "customs_agent_advance_payment_request"))
    }

    const PanelLateralChildren = useCallback(
        {
            IndexViewEdit: (
                <IndexViewEdit
                    onCloseModal={() => onOpenAndCloseLateralPanel()}
                    item={shippingOrder}
                    onEditRequest={onEditCustomsData}
                />
            ),
            IndexSendDocuments: (
                <IndexSendDocuments
                    onCloseModal={() => onOpenAndCloseLateralPanel()}
                    item={shippingOrder}
                    onEditRequest={onSendAditionalDocuments}
                    onUploadAtitionalDocuments={onUploadAtitionalDocuments}
                    onRemoveFile={onRemoveAditionalFiles}
                    onUploadPaidRequestCustoms={onUploadPaidRequestCustoms}
                    onRemovePaidRequestCustoms={onRemovePaidRequestCustoms}
                    onUploadCustomsAgentExpenseAccount={onUploadCustomsAgentExpenseAccount}
                    onRemoveCustomsAgentExpenseAccount={onRemoveCustomsAgentExpenseAccount}
                    onUploadCustomsAgentAdvancePaymentRequest={onUploadCustomsAgentAdvancePaymentRequest}
                    onRemoveCustomsAgentAdvancePaymentRequest={onRemoveCustomsAgentAdvancePaymentRequest}
                />
            )

        },
        [identifierPanelLateral, selectedItem]
    )

    const onRowClick = (item, event) => {
        onLateralPanelConfig('IndexViewEdit')
        setSelectedItem(item)
    }

    const onRowClickAditionalDocuments = (item, event) => {
        onLateralPanelConfig('IndexSendDocuments')
        setSelectedItem(item)
    }

    const setOpenDialog = (value) => {
        setOpenAvailableOperationsDialog(value)
    }

    const onLateralPanelConfig = (identifier) => {
        setIdentifierPanelLateral(identifier)
        onOpenAndCloseLateralPanel()
    }

    const { LateralPanelComponent, onOpenAndCloseLateralPanel } = LateralPanelContainer({
        children: PanelLateralChildren[identifierPanelLateral],
        identifier: identifierPanelLateral,
    })

    const onViewPartNumber = (query) => {
        dispatch(searchByPartNumbersByQury(query)).then((data) => {
            showPlotsFromPartNumber(
                data[0].drawingName + '.pdf',
                data[0].companyToken
            )
        })
    }

    let optonsAvalinable = shippingOrder ? shippingOrder.get_available_operations : []
    return (
        <Paper style={{ padding: '10px' }}>
            <FloatingButton open={setOpenDialog} />
            <Card style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <CardHeader
                    title={'Folio :' + shippingOrder.folio}
                    avatar={<img
                        src={supplierLogo ? urlImageSupplier : yourlogohere}
                        alt='logoSupplier'
                        style={{
                            maxHeight: 80
                        }}
                    />}
                    subheader={shippingOrder.creation_date_long}
                />
                <div style={{ display: 'flex', flexDirection: 'column', margin: '20px' }}>
                    <Typography style={{ color: 'gray' }}>{shippingOrder.full_supplier}</Typography>
                    {supplier && <Typography style={{ color: 'gray' }}>{supplier.rfc}</Typography>}
                    {supplier && <Typography style={{ color: 'gray' }}>{supplier.full_address}</Typography>}
                </div>
            </Card>
            <DialogAvailableOperations
                userRolesByCompany={userRolesByCompany}
                options={optonsAvalinable}
                openAvailableOperationsDialog={openAvailableOperationsDialog}
                setOpenDialog={setOpenDialog}
                onSendCustomsBrokerInformation={onSendAditionalDocumentsWithStatus}
            />
            <List style={{ backgroundColor: '#F9F9F9' }}>
                <ListItem>
                    <ListItemText
                        primary={<div style={{ display: 'flex', gap: '15px' }}>
                            <AccountCircleOutlined style={{ color: '#86EDCD' }} />
                            <Typography component="span" variant="body2" color="textSecondary">
                                <strong> <Translate id="importRequests.customsBroker" /></strong>
                            </Typography>
                        </div>
                        } />
                    {shippingOrder.canEditForeignTrade && <div >
                        <Button onClick={() => onRowClick(shippingOrder)}>
                            <Typography style={{ marginRight: '8px' }}><Translate id="common.edit" /></Typography>
                            <Edit style={{ color: '#4377C4' }} />
                        </Button>
                    </div>}
                </ListItem>
            </List>
            <List>
                <ListItem>
                    <ListItemText
                        secondary={
                            <React.Fragment>
                                <Typography component="span" variant="body2" color="textPrimary">
                                    <strong><Translate id="importRequests.customsBrokerReference" />:</strong>
                                </Typography>
                                {shippingOrder.advance_agent_customs}
                            </React.Fragment>
                        } />
                    <ListItemText
                        secondary={
                            <React.Fragment>
                                <Typography component="span" variant="body2" color="textPrimary">
                                    <strong><Translate id="importRequests.customsBrokerAdvance" />:</strong>
                                </Typography>
                                {shippingOrder.advance_agent_customs_data}
                            </React.Fragment>
                        } />
                </ListItem>
                <ListItem>
                    <ListItemText
                        secondary={
                            <React.Fragment>
                                <Typography component="span" variant="body2" color="textPrimary">
                                    <strong> <Translate id="common.comments" />:</strong>
                                </Typography>
                                {shippingOrder.observations}
                            </React.Fragment>
                        } />
                </ListItem>
            </List>
            <Divider />
            <List style={{ backgroundColor: '#F9F9F9' }}>
                <ListItem>
                    <Assignment style={{ color: '#86EDCD' }} />
                    <ListItemText
                        secondary={
                            <Typography component="span" variant="body2" color="textSecondary">
                                <strong> <Translate id="importRequests.partNumbers" /></strong>
                            </Typography>
                        } />
                </ListItem>
                <DataTable
                    data={shippingOrder.details}
                    configuration={TableConfiguration}
                    onRowClick={(item) => onViewPartNumber(item.part_number_code)}
                />
            </List>
            <List >
                <ListItem>
                    <Assignment style={{ color: '#86EDCD' }} />
                    <ListItemText
                        secondary={
                            <Typography component="span" variant="body2" color="textSecondary">
                                <strong> <Translate id="importRequests.sharedFiles" /></strong>
                            </Typography>
                        } />
                </ListItem>
            </List>


            {<List style={{ backgroundColor: '#F9F9F9' }}>
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.invoice" /></strong>}
                    />
                </ListItem>
                {shippingOrder.invoices && shippingOrder.invoices.map((item) => {
                    return (
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText

                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                    )
                })}
                {documents.InvoiceAttachments && documents.InvoiceAttachments.map((item) => {
                    return (
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText

                                primary={<Typography>{item.Name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={item.FilePath}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                    )
                })}
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.packingSerialNumber" /></strong>}
                    />
                </ListItem>
                {shippingOrder.packing && shippingOrder.packing.map((item) => {
                    return (
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText
                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                    )
                })}
                {documents.PackingAttachments && documents.PackingAttachments.map((item) => {
                    return (
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText

                                primary={<Typography>{item.Name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={item.FilePath}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                    )
                })}
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.certificate" /></strong>}
                    />
                </ListItem>
                {shippingOrder.certificate_origin && shippingOrder.certificate_origin.map((item) => {
                    return (
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText
                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                    )
                })}
                {documents.CertificateAttachments && documents.CertificateAttachments.map((item) => {
                    return (
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText

                                primary={<Typography>{item.Name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={item.FilePath}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                    )
                })}
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.qualityCertificate" /></strong>}
                    />
                </ListItem>
                {shippingOrder.certificate_quality && shippingOrder.certificate_quality.map((item) => {
                    return (
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText
                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                    )
                })}
                <Divider />
                <List style={{ backgroundColor: 'white' }}>
                    <ListItem>
                        <Assignment style={{ color: '#86EDCD' }} />
                        <ListItemText
                            secondary={
                                <Typography component="span" variant="body2" color="textSecondary">
                                    <strong> Archivos agente aduanal</strong>
                                </Typography>
                            } />
                    </ListItem>
                </List>
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.additionalDocuments" /></strong>}
                    />
                    {shippingOrder.canEditForeignTrade && <Button onClick={() => onRowClickAditionalDocuments(shippingOrder)}>
                        <Typography style={{ marginRight: '8px' }}><Translate id="importRequests.addDocument" /></Typography>
                        <AddCircle style={{ color: '#4377C4' }} />
                    </Button>}
                </ListItem>


                {shippingOrder.aditional_documents && shippingOrder.aditional_documents.map((item) => {
                    return (<>
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText
                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                        <Divider />
                    </>
                    )
                })}
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.addPaidRequestCustoms" /></strong>}
                    />
                    {shippingOrder.canEditForeignTrade && <Button onClick={() => onRowClickAditionalDocuments(shippingOrder)}>
                        <Typography style={{ marginRight: '8px' }}><Translate id="importRequests.addDocument" /></Typography>
                        <AddCircle style={{ color: '#4377C4' }} />
                    </Button>}
                </ListItem>
                {shippingOrder.paid_request_customs && shippingOrder.paid_request_customs.map((item) => {
                    return (<>
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText
                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                        <Divider />
                    </>
                    )
                })}
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.addCustomsAgentExpenseAccount" /></strong>}
                    />
                    {shippingOrder.canEditForeignTrade && <Button onClick={() => onRowClickAditionalDocuments(shippingOrder)}>
                        <Typography style={{ marginRight: '8px' }}><Translate id="importRequests.addDocument" /></Typography>
                        <AddCircle style={{ color: '#4377C4' }} />
                    </Button>}
                </ListItem>
                {shippingOrder.customs_agent_expense_account && shippingOrder.customs_agent_expense_account.map((item) => {
                    return (<>
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText
                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                        <Divider />
                    </>
                    )
                })}
                <ListItem>
                    <Attachment style={{ color: '#BDBDBD' }} />
                    <ListItemText
                        secondary={<strong><Translate id="importRequests.addCustomsAgentAdvancePaymentRequest" /></strong>}
                    />
                    {shippingOrder.canEditForeignTrade && <Button onClick={() => onRowClickAditionalDocuments(shippingOrder)}>
                        <Typography style={{ marginRight: '8px' }}><Translate id="importRequests.addDocument" /></Typography>
                        <AddCircle style={{ color: '#4377C4' }} />
                    </Button>}
                </ListItem>
                {shippingOrder.customs_agent_advance_payment_request && shippingOrder.customs_agent_advance_payment_request.map((item) => {
                    return (<>
                        <ListItem style={{ backgroundColor: 'white' }}>

                            <ListItemText
                                primary={<Typography>{item.name}</Typography>}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <IconButton target='_blank' href={`${process.env.REACT_APP_SIP_URL_FILES_PLANNING}/${item.relativePath}`}>
                                    <CloudDownload style={{ color: '#4377C4' }} />
                                </IconButton>
                            </div>
                        </ListItem>
                        <Divider />
                    </>
                    )
                })}
            </List>}
            <LateralPanelComponent />
        </Paper>
    )
}
const TableConfiguration = {
    columns: [
        {
            header: <Translate id="shippingOrder.purchaseOrder" />,
            dataSource: 'purchase_order',
        },
        {
            header: <Translate id="shippingOrder.codePartNumber" />,
            dataSource: 'part_number_code',
        }, {
            header: <Translate id="shippingOrder.productoDescription" />,
            dataSource: 'part_number_description',
        }, {
            header: <Translate id="shippingOrder.quantityofMaterial" />,
            dataSource: 'quantity_of_material',
        }, {
            header: <Translate id="shippingOrder.productoMeasurementUnit" />,
            dataSource: 'part_number_um',
        }, {
            header: <Translate id="shippingOrder.unitPrice" />,
            dataSource: 'price',
        }]
}
export default withauthenticatedLayout(Show)